import React from "react";
import { Label } from "../fields/Fields";

export type RadioSelectCardProps = {
  children: React.ReactNode;
  className?: string;
  color?: "blue" | "green" | "red" | "yellow" | "indigo" | "gray";
  size?: "sm" | "md" | "lg";
  value?: { value: any; setValue: any; onChange: any };
  vertical?: boolean;
  name: string;
  radioSelectCardItem: RadioSelectCardItem[];
  [key: string]: any;
};

export type RadioSelectCardItem = {
  id: string;
  title: React.ReactNode;
  value?: string | undefined;
  className?: string | undefined;
  disabled?: boolean;
  [key: string]: any;
};
const style = {
  sizes: {
    sm: "px-2 py-1 text-sm rounded",
    md: "px-4 py-3 text-base rounded-md",
    lg: "px-6 py-5 text-lg rounded-lg",
  },
  colors: {
    blue:   "cursor-pointer text-blue-500 border border-blue-200 hover:text-blue-900 hover:bg-blue-100 peer-checked:border-blue-600 peer-checked:text-white peer-checked:bg-blue-500",
    green:  "cursor-pointer text-green-500 border border-green-200 hover:text-green-900 hover:bg-green-100 peer-checked:border-green-600 peer-checked:text-white peer-checked:bg-green-500",
    red:    "cursor-pointer text-red-500 border border-red-200 hover:text-red-900 hover:bg-red-100 peer-checked:border-red-600 peer-checked:text-white peer-checked:bg-red-500",
    yellow: "cursor-pointer text-yellow-500 border border-yellow-200 hover:text-yellow-900 hover:bg-yellow-100 peer-checked:border-yellow-600 peer-checked:text-white peer-checked:bg-yellow-500",
    indigo: "cursor-pointer text-indigo-500 border border-indigo-200 hover:text-indigo-900 hover:bg-indigo-100 peer-checked:border-indigo-600 peer-checked:text-white peer-checked:bg-indigo-500",
    gray:   "cursor-pointer text-gray-500 border border-gray-200 hover:text-gray-900 hover:bg-gray-100 peer-checked:border-gray-600 peer-checked:text-white peer-checked:bg-gray-500"
  },
  disabled: "text-gray-300 border border-gray-100",
  vertical: "flex items-center space-y-0 space-x-2",
};

export const RadioSelectCard = ({
  children,
  className,
  color = "indigo",
  size = "md",
  value,
  vertical = false,
  name,
  label,
  type,
  radioSelectCardItem,
  ...props
}: RadioSelectCardProps) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(event.target.dataset.value);
    event.stopPropagation();
    console.log(event.target.dataset.value);
    value?.setValue(event.target.dataset.value);
  };

  return (
    <div className={`space-y-2 ${vertical ? style.vertical : ""} ${className}`}>
      <Label
        className={"mr-4 items-center text-sm font-medium text-gray-700"}
        id={"select"}
      >{label}</Label>
      {radioSelectCardItem.map((item) => {
        const returnValue = item.value ?? item.id;
        const className = item.className ?? "inline-flex items-center justify-between w-full";
        return (
        <div key={item.id} className="flex items-center">
          <input
            id={item.id}
            name={name}
            type="radio"
            data-value={returnValue}
            {...item.props}
            onChange={onChange}
            checked={value?.value === returnValue}
            className={'hidden peer'}
            disabled={item.disabled}
          />
          <label
            htmlFor={item.id}
            className={`${style.sizes[size]} ${className} ${!item.disabled ? style.colors[color] : style.disabled}`}
          >
            {item.title}
          </label>
        </div>
      )})}
    </div>
  );
};
